import React from 'react';
import createSvgIcon from './utils/createSvgIcon';

export default createSvgIcon(
  <React.Fragment>
    <path d="M7.41 18.59 8.83 20 12 16.83 15.17 20l1.41-1.41L12 14z" />
    <path d="M16.59 5.41 15.17 4 12 7.17 8.83 4 7.41 5.41 12 10z" />
  </React.Fragment>,
  'UnfoldLess'
);
